const root = () => ({
  padding: 1.5
});
export {
  root
};
